/* ut-cs-buy.js — Task 6101 revision (item 2).
 *
 * The "Compatible Parts & Alternatives" block (#pp-tab-parts, cards .pp-cs-card)
 * showed a part, its price and its stock but gave no way to buy it. This adds a
 * real Add-to-Cart button to every in-stock card.
 *
 * Deliberately a REAL <form action="/cart/add" method="post"> rather than a
 * fetch: the site-wide quiet-add snippet (ut-quiet-add.liquid) intercepts
 * form[action*="/cart/add"] submits in the capture phase and turns them into an
 * AJAX add + toast. Reusing it means these buttons are silent for free, and if
 * that JS ever fails the form still degrades to a normal Shopify add.
 *
 * The section JS builds the cards from the portal API and stamps data-vid /
 * data-stock on each <a>. All the DOM work lives here because
 * sections/new-product-information.liquid is ~320KB, at the template ceiling.
 *
 * A <form>/<button> cannot live inside an <a> (invalid, and a click would
 * navigate), so each card is rewrapped:
 *     <a class="pp-cs-card" data-vid>       ->  <div class="pp-cs-card">
 *                                                 <a class="pp-cs-link">…</a>
 *                                                 <form class="pp-cs-buy">…</form>
 *                                               </div>
 */
(function () {
  'use strict';

  var SEL = 'a.pp-cs-card[data-vid]';

  function upgrade(a) {
    var vid = a.getAttribute('data-vid');
    var inStock = a.getAttribute('data-stock') === '1';

    /* Consume the markers so the card can never be upgraded twice. */
    a.removeAttribute('data-vid');
    a.removeAttribute('data-stock');

    var parent = a.parentNode;
    if (!parent) return;

    var card = document.createElement('div');
    card.className = 'pp-cs-card';
    parent.insertBefore(card, a);
    a.className = 'pp-cs-link';
    card.appendChild(a);

    if (inStock && vid) {
      var form = document.createElement('form');
      form.className = 'pp-cs-buy';
      form.method = 'post';
      form.action = '/cart/add';
      form.setAttribute('accept-charset', 'UTF-8');

      var id = document.createElement('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = vid;

      var qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      qty.value = '1';

      var btn = document.createElement('button');
      btn.type = 'submit';
      btn.className = 'pp-cs-atc';
      btn.textContent = 'Add to Cart';

      form.appendChild(id);
      form.appendChild(qty);
      form.appendChild(btn);
      card.appendChild(form);
    } else {
      var out = document.createElement('span');
      out.className = 'pp-cs-atc pp-cs-atc--out';
      out.textContent = 'Out of Stock';
      card.appendChild(out);
    }
  }

  function scan() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) upgrade(nodes[i]);
  }

  function start() {
    scan();
    /* Cards are appended after an async portal fetch, and the section re-renders
       on variant change, so keep watching. Scoped to the cross-sell container
       when it exists to keep the observer cheap. */
    var root = document.getElementById('portal-cross-sell-section') || document.body;
    if (!root || typeof MutationObserver !== 'function') return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; scan(); });
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
